import { useEffect } from 'react';
import { getEnvironment } from 'toolkit/environment/environment/environment';
import { selectActingUser } from '../../slices/actingUserSlice';
import { useAppSelector } from '../../store-hooks';

export const useFeatureFlag = (flag: string): boolean => {
  const actingUser = useAppSelector(selectActingUser);
  const environment = getEnvironment();
  useEffect(() => {
    if (actingUser?.featureFlags) {
      if (!(flag in actingUser.featureFlags) && !environment.production) {
        console.error(
          `Feature flag ${flag} doesn't exist in DB. Check your spelling, add it to the DB (might include migrating from old system)`
        );
      }
    }
  }, [flag, actingUser?.featureFlags, environment.production]);

  return !!actingUser?.featureFlags[flag];
};
